import { render, staticRenderFns } from "./ManterDasboardFormacaoGreView.vue?vue&type=template&id=3ee5f4a8"
import script from "./ManterDasboardFormacaoGreView.vue?vue&type=script&lang=js"
export * from "./ManterDasboardFormacaoGreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports